import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { registerUser } from "../services/authService";
import VerificationModal from "../components/VerificationModal";
import Preloader from "../../shared/components/Preloader";
import "../styles/Register.css";
import "../../shared/styles/Global.css";
import "react-toastify/dist/ReactToastify.css";
import AppFooter from "../../shared/components/AppFooter";

const Register = () => {
  const [formData, setFormData] = useState({
    email: "",
    confirmEmail: "",
    password: "",
    confirmPassword: "",
    name: "",
    surname: "",
    country: "",
    city: "",
    phone: "",
    profession: "",
    termsAccepted: false,
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const sanitizeInput = (text) => {
    return text.trim().replace(/[<>"]/g, "");
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.termsAccepted) {
      toast.error("Debes aceptar los términos y condiciones.");
      return;
    }

    setLoading(true);

    try {
      await registerUser(
        formData.email,
        formData.confirmEmail,
        formData.password,
        formData.confirmPassword,
        sanitizeInput(formData.name),
        sanitizeInput(formData.surname),
        sanitizeInput(formData.country),
        sanitizeInput(formData.city),
        formData.phone,
        sanitizeInput(formData.profession)
      );
      setIsModalOpen(true);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <main className="registerMain fadeIn">
        <section className="registerSection">
          <div className="registerContainer">
            <img src="/images/patientManager1.svg" alt="Patient Manager" />

            {loading ? (
              <Preloader />
            ) : (
              <form onSubmit={handleSubmit}>
                <input
                  type="email"
                  name="email"
                  placeholder="Correo electrónico"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <input
                  type="email"
                  name="confirmEmail"
                  placeholder="Confirmar correo electrónico"
                  value={formData.confirmEmail}
                  onChange={handleChange}
                  required
                />
                <input
                  type="password"
                  name="password"
                  placeholder="Contraseña"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <input
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirmar contraseña"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="name"
                  placeholder="Nombre"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="surname"
                  placeholder="Apellido"
                  value={formData.surname}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="country"
                  placeholder="País"
                  value={formData.country}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="city"
                  placeholder="Ciudad"
                  value={formData.city}
                  onChange={handleChange}
                  required
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Teléfono"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="profession"
                  placeholder="Profesión"
                  value={formData.profession}
                  onChange={handleChange}
                  required
                />
                <label className="labelCheckbox">
                  <input
                    type="checkbox"
                    name="termsAccepted"
                    checked={formData.termsAccepted}
                    onChange={handleChange}
                  />
                  <p>
                    Acepto los{" "}
                    <a
                      href="https://blog.patientmanager.com.ar/terminos-y-condiciones/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      términos y condiciones
                    </a>
                    .
                  </p>
                </label>
                <button type="submit">Registrarse</button>
              </form>
            )}
          </div>

          <VerificationModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        </section>
      </main>

      <ToastContainer position="top-center" autoClose={2500} />

      <AppFooter />
    </>
  );
};

export default Register;
